export default function CTA() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-[60vh] min-h-[480px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/279f48eb6b0ed53fd5941397f66ae328.jpg"
          alt="Perfect paint finish"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
      </div>

      {/* Gold top border */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-600/50 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-600/50 to-transparent"></div>

      <div className="relative z-10 w-full max-w-[1600px] mx-auto px-6 md:px-16">
        <div className="max-w-2xl">
          <span className="text-yellow-600 text-xs tracking-[0.4em] uppercase font-light">No Obligation</span>
          <h2 className="font-serif text-4xl md:text-6xl text-white mt-4 mb-6 leading-tight">
            Get Your Free<br />
            <span className="text-yellow-400 italic">Estimate Today</span>
          </h2>
          <p className="text-white/60 text-base md:text-lg leading-relaxed mb-10 font-light max-w-lg">
            Experience the royal treatment. Contact us for a detailed estimate and consultation — no pressure, just perfection.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => scrollTo('contact')}
              className="whitespace-nowrap flex items-center justify-center gap-3 px-10 py-4 text-sm tracking-widest uppercase text-yellow-300 bg-gradient-to-r from-purple-800 via-purple-900 to-black border border-yellow-600/40 rounded-full hover:border-yellow-500 hover:from-purple-700 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-file-list-3-line"></i>
              Get Estimate
            </button>
            <a
              href="tel:7606664151"
              className="whitespace-nowrap flex items-center justify-center gap-3 px-10 py-4 text-sm tracking-widest uppercase text-white bg-transparent border border-white/20 rounded-full hover:border-yellow-600/50 hover:text-yellow-400 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-phone-line text-yellow-500"></i>
              (760) 666-4151
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
